import Moment from 'moment/moment'
import { getAllDocsByQueries } from './collectionBaseWorker'
import { Collection, WhereField } from '../../shared/constants'
import { where } from "firebase/firestore"

export const allTicketsByCashiers = async ({ caixasIds }) => {
    var tickets = [];
    const chunkSize = 10;
    for (let i = 0; i < caixasIds.length; i += chunkSize) {
        const cashiersSliced = caixasIds.slice(i, i + chunkSize);
        if (cashiersSliced.length > 0) {
            const items = await getAllDocsByQueries({
                collection: Collection.TICKET,
                queries: [
                    where(WhereField.CAIXAS_IDS, "array-contains-any", cashiersSliced)
                ]
            })
            tickets.push(items)
        }
    }
    const allTickets = tickets.flatMap(e => e)
    const ids = Array.from(new Set(allTickets.map((item) => item.id)))
    var newTickets = []
    ids.forEach(e => {
        const ticket = allTickets.filter(f => f.id === e)[0]
        newTickets.push(ticket)
        return newTickets
    })
    return newTickets
}

export const allTicketsByDates = async ({ estacionamentoId, startDate, endDate }) => {
    var newStartDate = Moment(startDate.toDate()).toDate()
    var newEndDate = Moment(endDate.toDate()).toDate()
    return await getAllDocsByQueries({
        collection: Collection.TICKET,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.CREATE_AT, ">=", newStartDate),
            where(WhereField.CREATE_AT, "<=", newEndDate)
        ]
    })
}